import { dto_selected_final_merchant_or_product } from "../../../../classes/dto-selected-merchant-or-product";
import { api_LoadAllPromo } from "../../../../connection/api/api-cart";
import { KEY_GENERATOR } from "../../../../functions/funtion";
import { Colors } from "../../../../util/colors";
import PlaceHolder from "../../../home/components/product-list-place-holder/product-list-place-holder";
import React from "react";

export default class LaodAllPromo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      IsLoading: false,
      data: [],
      dataLength: 0,
    };
  }

  async componentDidMount() {
    await this.LoadAllPromos();
  }

  async LoadAllPromos() {
    this.setState({ IsLoading: true });

    let data = await api_LoadAllPromo(
      dto_selected_final_merchant_or_product.MID,
    );
    let d = JSON.parse(data);
    let objData = JSON.parse(d);
    this.setState({
      IsLoading: false,
      data: objData[0],
      dataLength: objData[0].length,
    });
  }

  render() {
    return (
      <div>
        {this.state.IsLoading ? (
          <PlaceHolder />
        ) : (
          <>
            {this.state.data.map((rs) => {
              return (
                <div
                  style={{
                    padding: 5,
                    borderRadius: "5px",
                    border: "1px solid " + Colors.DarkGreyScale,
                    height: "100px",
                    marginBottom: 20,
                    backgroundColor: Colors.LightGreyScale,
                  }}
                  key={KEY_GENERATOR()}
                  onClick={() => {
                    this.props.PromoApply(rs);
                  }}
                >
                  <p
                    style={{
                      fontWeight: "bold",
                      fontSize: 14,
                      marginTop: 5,
                      marginBottom: 0,
                    }}
                  >
                    {rs.PromoHeading}
                  </p>
                  <p
                    style={{
                      fontSize: 12,
                      color: "black",
                      marginTop: 5,
                      marginBottom: 0,
                    }}
                  >
                    {rs.Description}
                  </p>
                  <div style={{ height: 5 }}></div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: 5,
                      marginBottom: 0,
                    }}
                  >
                    <div
                      style={{
                        width: "auto",
                        padding: "8px",
                        fontSize: 11,
                        borderRadius: 3,
                        textAlign: "center",
                        color: Colors.DarkGreyScale,
                        fontFamily: "Medium",
                        backgroundColor: 'white',
                        height: "30px",
                        fontWeight: 'bold'
                      }}
                      onClick={() => {
                        this.props.PromoApply(rs);
                      }}
                    >
                      Use code {rs.PromoCode}
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}
        {this.state.dataLength <= 0 ? (
          <p style={{ color: "red", textAlign: "center" }}>No Promo Found</p>
        ) : (
          ""
        )}
      </div>
    );
  }
}
